export default function Privacy(){
    return (
        <div className="App">
            <header className="App-header">
                <p>Here will be the Privacy Policy</p>
            </header>
        </div>
    )
}